module.exports = __webpack_public_path__ + "media/images/team-2-5bbdf63b.png";